import React, { useContext, useEffect, useState } from 'react';
import {CitizenScienceIntroductionContext} from './citizenScienceIntroductionContext';

const rules = [
  ['Any animal or bird moving on the ground or in a tree?', 'S', 'Real motion', 'Choose "real" even if the moving animal or bird is outside the highlighted box!'],
  ['Spot a predator?', 'P', 'Predator'],
  ['Spot something interesting you want to highlight?', 'H', 'Interesting'],
  ['Birds flying, plants/trees swaying or water moving?', 'N', 'False alarm'],
  ['Unsure? Don’t guess.', 'Space bar', 'Not sure'],
  ['Made a mistake? Undo it.', 'U', 'Undo'],
];

export function MotionReviewRules({ compact = false }) {
  const openIntroduction = useContext(CitizenScienceIntroductionContext);
  const [roomy, setRoomy] = useState(() => window.innerHeight >= 720);
  useEffect(() => {
    const resize = () => setRoomy(window.innerHeight >= 720);
    window.addEventListener('resize', resize);
    return () => window.removeEventListener('resize', resize);
  }, []);
  return <details className="cr-motion-rules" open={!compact && roomy}>
    <summary>{compact ? 'Review rules' : 'Review rules and shortcuts'}</summary>
    <div className="cr-motion-rules-body"><ul>{rules.map(([text, shortcut, answer, hint]) => <li key={text}><span>{text}{hint && <span className="cr-motion-rule-hint">{hint}</span>}</span><span className="cr-motion-rule-key">{compact ? answer : <>Press <kbd>{shortcut}</kbd></>}</span></li>)}</ul>
    {compact && <p className="cr-small cr-muted">Tap the matching answer below. Predator and Interesting also save Real motion.</p>}
    {openIntroduction && <button type="button" className="cr-text-button cs-introduction-link" onClick={openIntroduction}>Open introduction</button>}
    </div>
  </details>;
}

export function MotionReviewNotice({ notice }) {
  const undo = notice === 'Last motion review undone. Please check this clip again.';
  return <div className={`cr-announcement${undo ? ' cr-announcement--undo' : ''}`} role="status" aria-live="polite">
    {undo ? <><span className="cr-announcement-full">{notice}</span><span className="cr-announcement-short" aria-hidden="true">Undone.</span></> : notice}
  </div>;
}

export function MotionFlagActions({ compact = false, disabled, onFlag }) {
  const buttons = <>
    <button type="button" className="cr-flag-action" aria-label="Possible predator" aria-keyshortcuts="P" disabled={disabled} onClick={() => onFlag('predator')}>{compact ? 'Predator' : 'Possible predator'} <kbd aria-hidden="true">P</kbd></button>
    <button type="button" className="cr-flag-action" aria-label="Interesting sighting" aria-keyshortcuts="H" disabled={disabled} onClick={() => onFlag('interesting')}>{compact ? 'Interesting' : 'Interesting sighting'} <kbd aria-hidden="true">H</kbd></button>
  </>;
  return compact ? <div className="cr-motion-mobile-flags" role="group" aria-label="Flag an animal sighting">{buttons}</div>
    : <fieldset className="cr-motion-flags" disabled={disabled}><legend>Flag an animal sighting</legend>{buttons}</fieldset>;
}

export function MotionMobileActions({ disabled, onSubmit, undoButton }) {
  return <div className="cr-motion-mobile-actions">
    <div className="cr-motion-mobile-row cr-motion-mobile-primary">
      <button className="cr-verdict" type="button" aria-keyshortcuts="N" disabled={disabled} onClick={() => onSubmit('false_alarm')}>False alarm</button>
      <button className="cr-verdict cr-motion-animal" type="button" aria-keyshortcuts="S" disabled={disabled} onClick={() => onSubmit('animal')}>Real motion</button>
    </div>
    <MotionFlagActions compact disabled={disabled} onFlag={(flag) => onSubmit('animal', flag)} />
    <div className="cr-motion-mobile-row">
      <button className="cr-verdict" type="button" aria-keyshortcuts="Space" disabled={disabled} onClick={() => onSubmit('unsure')}>Not sure</button>
      {undoButton}
    </div>
  </div>;
}
